import { PATHS_VALUES, ROUTES_PATHS, } from "../../../shared/enums/routing-paths-values";
export var HEADER_ROUTES = [
    {
        label: "Стартовая страница",
        id: 1,
        url: PATHS_VALUES.STARTING_PAGE,
    },
    {
        label: "Модуль статистики",
        id: 2,
        url: PATHS_VALUES.STATISTIC,
    },
    {
        label: "Модуль конфигурации",
        id: 3,
        url: PATHS_VALUES.CONFIGURATION,
    },
];
export var fitredRoutes = HEADER_ROUTES.filter(function (item) { return !item.url.includes(ROUTES_PATHS.STARTING_PAGE); });
